"use client";
import React, { useEffect, useState } from 'react'
import style from "./style.module.css"
import { useAuthStore } from '@/app/store/authstore';
import { useLoggedOutDialogStore } from '@/app/store/LoggedOutDialogState';
import { googleLogout } from "@react-oauth/google";
import deviceInfo from '@/app/utils/deviceInfo';
import tohash from '@/app/utils/tohash';
import { fetchWithLoader } from '@/app/utils/api';
import { useToastStore } from '@/app/store/localapi';
import { useRouter } from 'next/navigation';

function Loggedout() {
  const isOpen = useLoggedOutDialogStore((s) => s.isOpen);
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((state) => state.logout);
  const { showToast } = useToastStore()
  const [mounted, setMounted] = useState(false);
  const router = useRouter();

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleLogout = async () => {
    logout();
    googleLogout();
    if (typeof window !== 'undefined' && window) {
      // eslint-disable-next-line
      const win = window as any;
      if (win.FB) {
        try {
          // Facebook requires HTTPS for getLoginStatus
          const isHttps = window.location.protocol === 'https:';
          if (!isHttps && window.location.hostname !== 'localhost') {
            console.warn('Facebook logout skipped: HTTPS required');
            return;
          }
          
          {/*eslint-disable-next-line */ }
          win.FB.getLoginStatus((response: any) => {
            if (response.status === 'connected') {
              win.FB.logout();
            }
          });
        } catch (error) {
          console.warn('Facebook logout failed:', error);
        }
      }
    }
    const device = deviceInfo()
    if(!user)return;
    const deviceId = tohash(`${device.name}${device.platform}${device.os}${user?.user_email}${device.version}`)

    await fetchWithLoader('user_logout_json.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ device_id: deviceId })
    }).then(res => res.json()).then(data => {
      // console.log(data)
      showToast("Logout Successful", "success");
    }).catch(err => {
      console.error(err);
      showToast("Logout Failed", "error");
    });
    router.push('/login');
  };

  if (!mounted) return null;

  return (
    <>
      <div className={style.logout} style={{ display: isOpen && user ? "flex" : "none" }}>
        <div className={style.logoutContent}>
          <h2>Logged Out</h2>
          <p>You&#39;ve been signed out since your account is being used on multiple devices.</p>
          <div className={style.logoutBtns}>
            <button type="submit" className={`${style.later}`} onClick={handleLogout}>Later</button>
            <button className={`${style.loginAgain} ${style.active}`} onClick={handleLogout}>Log In Again</button>
          </div>
        </div>
      </div>
    </>
  )
}
export default Loggedout
